{
  "fields": {
    "supplier": "Supplier",
    "purchase": "Purchase",
    "createdBy": "Recorded by"
  },
  "picker": {
    "placeholder": "Choose a supplier",
    "search": "Search name, code or mobile…",
    "empty": "No supplier matches.",
    "failed": "Suppliers couldn't be loaded. Try again."
  },
  "list": {
    "supplierFilter": "Filter by supplier",
    "allSuppliers": "All suppliers",
    "unitFilter": "Requesting unit",
    "allUnits": "All units",
    "emptyFilteredBody": "Try another search, supplier or period.",
    "export": "Export view",
    "exportHint_one": "CSV of the {{n}} document in this view",
    "exportHint_other": "CSV of the {{n}} documents in this view",
    "exported_one": "{{n}} document exported",
    "exported_other": "{{n}} documents exported",
    "exportedView": "The view was exported",
    "mine": "Mine",
    "rowActions": "Actions for {{number}}",
    "methodFilter": "Filter by method",
    "allMethods": "All methods",
    "accountFilter": "Filter by cash or bank account",
    "allAccounts": "All accounts"
  },
  "errors": {
    "PURCHASE_POSTED": "Only a draft purchase can be edited, posted or deleted. A posted purchase can only be voided.",
    "SUPPLIER_REQUIRED": "Choose the supplier first. A draft can be saved without one, but it can't be posted or submitted for approval until it has one.",
    "SUPPLIER_HIDDEN": "Suppliers are hidden from you, so you can't choose, change, filter or sort by a supplier. Save the purchase without one: someone who can view suppliers adds it.",
    "PURCHASE_NOT_POSTED": "Only a posted purchase can be voided, paid or returned.",
    "PURCHASE_HAS_RETURNS": "Supplier returns were issued against this purchase. Void them first.",
    "PURCHASE_HAS_PAYMENTS": "Payments are applied to this purchase. Remove it from those payments first.",
    "PURCHASE_HAS_RETURN_CREDITS": "A supplier return is applied to this purchase. Remove it from the purchase's settlements, or void that return, first.",
    "STOCK_ISSUED_SINCE_RECEIPT": "Some of these goods were sold or issued since they were received, at an average cost. Taking them out now at their purchase cost would leave stock value with no quantity behind it. Correct the stock with a stock adjustment instead.",
    "DRAFT_OUTDATED": "A product on this draft was archived since it was saved. Choose an active product, save the draft and post it again.",
    "STOCK_ALREADY_USED": "Some of the goods this purchase brought in have already been sold or moved. Return them to the supplier instead of voiding.",
    "STOCK_NOT_ON_HAND": "Some of these goods are no longer in the warehouse, so they can't go back to the supplier.",
    "SUPPLIER_INACTIVE": "This supplier is inactive or archived. Reactivate the supplier before posting a purchase from them.",
    "SUPPLIER_ARCHIVED": "This supplier is archived. Restore the supplier first.",
    "SUPPLIER_RETURN_POSTED": "Only a draft supplier return can be edited, posted or deleted.",
    "SUPPLIER_RETURN_NOT_POSTED": "Only a posted supplier return can be voided or applied.",
    "CREDIT_EXCEEDS_PURCHASE": "The return is more than is left to return or credit on the purchase.",
    "RETURN_EXCEEDS_PURCHASED": "A quantity is more than can still be returned from the purchase.",
    "RETURN_SHARE_TOO_SMALL": "Return this line in larger quantities: the amounts per unit are below one baisa.",
    "ALLOCATION_EXCEEDS_BALANCE": "An amount is more than what is left to pay on its purchase.",
    "ALLOCATION_EXCEEDS_PAYMENT": "The amounts add up to more than is left on this payment.",
    "ALLOCATION_EXCEEDS_CREDIT": "The amounts add up to more than is left on this supplier return.",
    "SOURCE_REFUNDED": "The supplier has refunded part of this credit. Void that supplier refund first.",
    "NO_MAIN_WAREHOUSE": "No main warehouse is set up. Ask an administrator to choose one under Inventory › Warehouses.",
    "WHOLE_UNITS_ONLY": "A product counted in whole units has a quantity with decimals.",
    "REFUND_EXCEEDS_CREDIT": "An amount is more than is left to refund on its credit.",
    "ORG_UNIT_REQUIRED": "Choose the org unit this purchase is for.",
    "ORG_UNIT_OUT_OF_SCOPE": "This org unit is outside the units you work for. Choose one of your units.",
    "CHEQUE_CLEARED": "The bank already paid out the cheque of this payment. Undo the cheque's clearing first.",
    "CHEQUE_NOT_CLEARED": "The cheque of this payment has not cleared yet. Take its credit back once the bank pays the cheque out."
  },
  "lines": {
    "cost": "Unit cost",
    "costInclusive": "Cost incl. VAT",
    "costOf": "Unit cost of line {{n}}",
    "account": "Charged to",
    "accountOf": "Account of line {{n}}",
    "defaultAccount": "Operating expenses (default)",
    "searchAccounts": "Search account code or name…",
    "noAccounts": "No expense or asset account matches.",
    "inventory": "Inventory (goods)",
    "fromProduct": "Goods: inventory. Services: operating expenses.",
    "accountKept": "Keeps the account chosen on the draft",
    "enterHint": "Enter on the last line adds a new one. A product starts at its last purchase cost (or its average cost): check it against the supplier's bill.",
    "costHint": {
      "last": "Last {{cost}} ({{date}})",
      "average": "Avg {{cost}}",
      "none": "Never bought",
      "exVat": "excl. VAT"
    },
    "sellPrice": {
      "sells": "Sells {{price}}",
      "margin": "margin {{margin}}",
      "editOf": "Change the selling price of line {{n}}",
      "title": "Selling price",
      "label": "Retail price per {{unit}}, excl. VAT",
      "hint": "Saved on the product now, for the till and invoices; this purchase is not changed.",
      "save": "Save price"
    }
  },
  "allocations": {
    "source": "Settled by",
    "payment": "Payment",
    "supplierReturn": "Supplier return",
    "purchase": "Purchase"
  },
  "allocate": {
    "limited": "Showing the {{n}} oldest open purchases.",
    "noOpen": "This supplier has no open purchases.",
    "noOpenBody": "The whole amount stays with the supplier as an advance, to apply to later purchases.",
    "tableLabel": "Open purchases",
    "overBalance": "More than is left to pay on this purchase.",
    "exceedsPayment": "The amounts applied add up to more than the payment. Lower them or raise the amount.",
    "refunded": "Refunded by the supplier",
    "refundedShort": "Refunded"
  },
  "print": {
    "purchase": "Purchase",
    "supplierReturn": "Debit note",
    "allowance": "Debit note",
    "supplier": "Supplier",
    "supplierCode": "Supplier code",
    "debitTo": "Debited to",
    "date": "Date",
    "voidBanner": "Void — this voucher is cancelled",
    "paymentVoucher": "Payment voucher",
    "refundVoucher": "Receipt voucher",
    "paidTo": "Paid to",
    "receivedFrom": "Received from",
    "supplierVat": "VAT no.",
    "payeeBank": "Supplier's bank account",
    "theSumOf": "The sum of",
    "method": "Method",
    "fromAccount": "Paid from",
    "intoAccount": "Received into",
    "reference": "Cheque or reference no.",
    "paymentOf": "Being payment of",
    "refundOf": "Being refund of",
    "onAccountOnly": "Advance payment, not yet applied",
    "billNo": "Supplier's bill",
    "advance": "Advance left with the supplier",
    "preparedBy": "Prepared by",
    "receivedBy": "Received by",
    "approvedBy": "Approved by",
    "receivedBySupplier": "Received by (supplier)"
  },
  "purchases": {
    "title": "Purchases",
    "subtitle": "Suppliers' bills for goods and services received: drafts, posted purchases and what we still owe.",
    "kind": "Purchase",
    "new": "New purchase",
    "newTitle": "New purchase",
    "newSubtitle": "Saved as a draft. Posting it receives the goods and gives it a number.",
    "editTitle": "Edit {{title}}",
    "editSubtitle": "Edit draft",
    "draftTitle": "Draft purchase",
    "noSupplierYet": "No supplier yet",
    "chooseSupplier": "Choose the supplier",
    "supplierHidden": "Supplier hidden",
    "supplierHiddenHint": "You can't view suppliers. Save the draft: someone who can adds the supplier and posts it.",
    "supplierToPost": "Choose the supplier before posting. You can save the draft without one.",
    "supplierToPostHidden": "A purchase is posted with its supplier: someone who can see suppliers adds it.",
    "saveDraft": "Save draft",
    "notDraftTitle": "This purchase is no longer a draft",
    "backToPurchase": "Back to purchase",
    "voidTitle": "This purchase is void",
    "draftNote": "This is a draft: it has no number, the goods aren't in stock and nothing is in the books yet. Post it once the goods and the supplier's bill have arrived.",
    "balance": "Balance owed",
    "noSettlements": "Nothing has been paid on this purchase yet.",
    "noSettlementsHint": "Record the payment to the supplier to settle it.",
    "mainWarehouse": "Main warehouse",
    "mainWarehouseNamed": "Main warehouse ({{code}})",
    "noUnit": "No unit",
    "warehouseNamed": "warehouse {{code}}",
    "chargedTo": "Charged to {{account}}",
    "searchLabel": "Search purchases",
    "searchPlaceholder": "Search number, supplier's invoice or supplier…",
    "views": {
      "label": "Purchase views",
      "all": "All",
      "drafts": "Drafts",
      "open": "Open",
      "overdue": "Overdue",
      "void": "Void",
      "owed": "owed"
    },
    "empty": {
      "all": "No purchases yet.",
      "body": "Record a supplier's bill for the goods or services you received.",
      "drafts": "No draft purchases.",
      "open": "Nothing is waiting to be paid.",
      "overdue": "Nothing is overdue.",
      "void": "No void purchases.",
      "mine": "You have no draft purchases."
    },
    "sections": {
      "purchase": "Purchase",
      "summary": "Summary",
      "settlements": "Payments and returns",
      "returns": "Supplier returns issued against it",
      "attachments": "Attachments",
      "document": "Purchase document"
    },
    "fields": {
      "purchaseDate": "Purchase date",
      "dueDate": "Due date",
      "supplierReference": "Supplier's invoice no.",
      "warehouse": "Receive into",
      "supplierReferenceShort": "Supplier's ref.",
      "orgUnit": "Requesting unit",
      "orgUnitShort": "Unit"
    },
    "hints": {
      "supplierReference": "The number on the supplier's own invoice.",
      "supplierOptional": "A draft can be saved without a supplier; posting needs one.",
      "dueDate": "{{days}} days after the purchase date unless you choose another date.",
      "warehouse": "The goods go into this warehouse when the purchase is posted.",
      "warehouseTagged": "Only untagged goods go into this warehouse; goods tagged to a project go straight to its site.",
      "orgUnit": "The part of the organisation the purchase is for. It decides who approves it and who can see it.",
      "lines": "Search a product by name, SKU or barcode, or describe a service or expense yourself. Services and free-text lines are charged to an expense account.",
      "notes": "For your own records; not sent to the supplier."
    },
    "actions": {
      "post": "Post purchase",
      "void": "Void purchase",
      "delete": "Delete draft",
      "recordPayment": "Record payment",
      "createReturn": "Return or allowance",
      "postMenu": "Post…",
      "deleteMenu": "Delete draft…",
      "voidMenu": "Void…",
      "duplicate": "Duplicate",
      "reissue": "Re-issue as a new draft"
    },
    "post": {
      "title": "Post this purchase from {{supplier}}?",
      "mainWarehouse": "the main warehouse",
      "body": "Total {{total}}. Posting gives it a number, receives the goods into {{warehouse}} at their net cost (after discount, without VAT) and records {{total}} owed to the supplier. It can't be edited afterwards, only voided.",
      "noReference": "The supplier's invoice number is empty: the bill will be hard to find later.",
      "duplicate_one": "Supplier's invoice {{reference}} is already on {{numbers}}.",
      "duplicate_other": "Supplier's invoice {{reference}} is already on {{numbers}}.",
      "capture": {
        "title": "Still to check",
        "intro": "From the reading, these are still open. You can post now, or go back and fix them first.",
        "line": "Line {{n}}: {{issues}}",
        "goToLine": "Go to line {{n}}",
        "goTo": "Go to it",
        "totalGap": "The lines and the bill’s total are {{difference}} apart",
        "totalGapNet": "The lines’ net and the bill’s net are {{difference}} apart",
        "issues": {
          "NO_PRODUCT": "no product matched",
          "PRODUCT_UNAVAILABLE": "the product can’t be bought",
          "LOW_CONFIDENCE": "the assistant wasn’t sure",
          "QUANTITY_UNREADABLE": "the quantity wasn’t read",
          "PRICE_FROM_TOTAL": "the price was worked out from the total",
          "PRICE_LAST_COST": "the price is the cost on record",
          "PRICE_MISSING": "no price",
          "WHOLE_UNITS": "a fraction of a whole unit",
          "LINE_TOTAL_MISMATCH": "the line total differs",
          "TAX_RATE_UNKNOWN": "the VAT rate to check"
        }
      }
    },
    "delete": {
      "title": "Delete this draft?",
      "body": "The draft purchase is removed. Nothing was received or booked yet."
    },
    "void": {
      "title": "Void {{number}}?",
      "body": "Its journal entry is reversed and the goods it received leave stock again. It is refused while payments or returns are applied to it, or once any of its goods have been sold or moved. The purchase stays on record, marked void.",
      "blocked": "Payments or returns are applied to this purchase. Remove them first, or the void will be refused.",
      "removeFirst_one": "Remove the payment applied to it first.",
      "removeFirst_other": "Remove the {{count}} payments applied to it first.",
      "returnCreditFirst": "Supplier return {{number}} is applied to it: remove it from the settlements, or void that return, first.",
      "returnFirst": "Void supplier return {{number}} issued against it first."
    },
    "toast": {
      "saved": "Draft saved",
      "posted": "Purchase {{number}} posted",
      "deleted": "Draft deleted",
      "voided": "{{number}} voided",
      "payNext": "Record the payment to the supplier?",
      "savedDraft": "Saved as a draft"
    },
    "list": {
      "daysLate_one": "{{count}} d",
      "daysLate_other": "{{count}} d",
      "daysOverdueSpoken_one": "{{count}} day overdue",
      "daysOverdueSpoken_other": "{{count}} days overdue"
    },
    "figures": {
      "label": "Purchase figures",
      "total": "Total",
      "vat": "incl. VAT {{amount}}",
      "settled": "Settled",
      "paidPart": "{{amount}} paid",
      "returnedPart": "{{amount}} returned",
      "returned": "Returned",
      "nothingPaid": "Nothing settled yet",
      "nothingOwed": "Nothing owed",
      "settledInFull": "Settled in full",
      "overdue_one": "{{count}} day overdue",
      "overdue_other": "{{count}} days overdue",
      "dueToday": "Due today",
      "dueIn_one": "Due in {{count}} day",
      "dueIn_other": "Due in {{count}} days"
    },
    "duplicateTitle": "Duplicate purchase",
    "duplicateSubtitle": "A copy of {{number}}, dated today. Enter the supplier's new invoice number.",
    "duplicateFailed": "The purchase to copy couldn't be loaded. Start from a blank form.",
    "saveAndPost": "Save and post",
    "duplicate": {
      "title_one": "Supplier's invoice {{reference}} is already on another purchase of this supplier",
      "title_other": "Supplier's invoice {{reference}} is already on {{count}} other purchases of this supplier",
      "row": "dated {{date}}, total {{total}}",
      "body": "Check it isn't the same bill entered twice. You can still save and post it."
    },
    "settlements": {
      "removed": "{{number}} taken off this purchase",
      "removeTitle": "Remove {{number}} from this purchase?",
      "removeBody": "{{amount}} goes back to it as unapplied credit, and the purchase is open again for that amount.",
      "removeNamed": "Remove {{number}} from this purchase",
      "void": "Nothing is applied: it is void.",
      "recordOne": "Record a payment"
    },
    "refShort": "Supplier's ref.",
    "intoWarehouse": "Into",
    "notes": "Notes",
    "stats": {
      "label": "Purchase figures",
      "open": "Open to pay",
      "overdue": "Overdue",
      "thisMonth": "Purchased this month",
      "drafts": "Drafts",
      "draftsDetail": "Waiting to be posted",
      "overdueShare": "{{percent}}% of the open balance is overdue"
    }
  },
  "payments": {
    "title": "Supplier payments",
    "subtitle": "Money paid to suppliers and the purchases it settles.",
    "kind": "Supplier payment",
    "new": "Pay a supplier",
    "newTitle": "Pay a supplier",
    "newSubtitle": "Posted to the books straight away. The number is assigned when you save.",
    "save": "Record payment",
    "searchLabel": "Search supplier payments",
    "searchPlaceholder": "Search number, reference or supplier…",
    "chooseSupplierFirst": "Choose the supplier to see their open purchases.",
    "remainder": "{{amount}} stays with the supplier as an advance, to apply to later purchases.",
    "creditTitle": "{{amount}} not applied yet",
    "creditBody": "It is an advance with the supplier. Apply it to their purchases when they are posted.",
    "voidTitle": "This payment is void",
    "noAllocations": "This payment isn't applied to any purchase.",
    "noAllocationsHint": "Apply it to the supplier's open purchases.",
    "unallocateBody": "The purchase is open again for that amount, and it goes back to the supplier as an advance.",
    "sections": {
      "payment": "Payment",
      "allocation": "Apply to purchases",
      "allocations": "Purchases settled"
    },
    "fields": {
      "date": "Payment date",
      "amount": "Amount paid",
      "account": "Paid from",
      "method": "Method"
    },
    "hints": {
      "reference": "Cheque or transfer number.",
      "allocation": "Apply the money to the supplier's open purchases, oldest first or amount by amount."
    },
    "actions": {
      "allocate": "Apply to purchases",
      "void": "Void payment",
      "allocateMenu": "Apply to purchases…",
      "printVoucher": "Print voucher",
      "voidMenu": "Void…"
    },
    "allocate": {
      "title": "Apply {{number}}",
      "body": "{{amount}} of this payment is not applied yet."
    },
    "void": {
      "title": "Void {{number}}?",
      "body": "The amounts applied to purchases are released and its journal entry is reversed. The payment stays on record, marked void.",
      "refundFirst": "Void refund {{number}} drawn from it first."
    },
    "refundChequeNotCleared": "Cheque {{number}} has not cleared yet: take the refund once the bank pays it out.",
    "toast": {
      "created": "Payment {{number}} recorded",
      "allocated": "Applied to purchases",
      "unallocated": "Removed from {{number}}",
      "voided": "{{number}} voided"
    },
    "empty": {
      "title": "No supplier payments yet.",
      "body": "Record money paid to a supplier.",
      "withCredit": "No payment has unapplied credit.",
      "void": "No void payments."
    },
    "views": {
      "label": "Payment views",
      "all": "All",
      "withCredit": "Unapplied credit",
      "void": "Void",
      "unapplied": "unapplied"
    },
    "advanceStamp": "Advance",
    "advanceHeld": "An advance with the supplier",
    "saveAndPrint": "Save and print",
    "stats": {
      "label": "Payment figures",
      "paid": "Paid",
      "thisMonth": "Paid this month",
      "credit": "Unapplied credit",
      "creditShare": "{{percent}}% of what was paid is still unapplied",
      "overdue": "Overdue purchases"
    }
  },
  "returns": {
    "title": "Supplier returns",
    "subtitle": "Goods sent back to suppliers and allowances they grant: debit notes that reduce what we owe.",
    "draftTitle": "Draft return",
    "kind": {
      "RETURN": "Return",
      "ALLOWANCE": "Allowance"
    },
    "kindHint": {
      "RETURN": "Goods or services going back from a posted purchase. Costs, discounts and VAT come from the purchase.",
      "ALLOWANCE": "A price reduction the supplier grants, with or without a purchase. No stock moves."
    },
    "new": "New supplier return",
    "newTitle": "New supplier return",
    "newSubtitle": "Saved as a draft. The number is assigned when you post it.",
    "editTitle": "Edit {{title}}",
    "editSubtitle": "Edit draft",
    "saveDraft": "Save draft",
    "notDraftTitle": "This supplier return is no longer a draft",
    "backToReturn": "Back to supplier return",
    "voidTitle": "This supplier return is void",
    "draftNote": "This is a draft: it isn't in the books yet and no stock has moved. Post it to reduce what we owe the supplier.",
    "creditTitle": "{{amount}} not applied yet",
    "creditBody": "It is credit we hold with the supplier. Apply it to their open purchases.",
    "applied": "Applied",
    "noAllocations": "This supplier return isn't applied to any purchase.",
    "unallocateBody": "The purchase is open again for that amount, and it goes back to the credit we hold with the supplier.",
    "remainder": "{{amount}} stays as credit with the supplier.",
    "searchLabel": "Search supplier returns",
    "searchPlaceholder": "Search number, purchase or supplier…",
    "kindFilter": "Filter by type",
    "allKinds": "Returns and allowances",
    "purchaseWarehouse": "The purchase's warehouse",
    "purchaseWarehouseNamed": "The purchase's warehouse ({{code}})",
    "choosePurchase": "Choose a purchase",
    "chooseSupplierFirst": "Choose the supplier first",
    "searchPurchases": "Search purchase number…",
    "noPurchases": "No posted purchases from this supplier.",
    "noPurchase": "Not against a purchase",
    "pickPurchase": "Choose the purchase the goods came in on.",
    "pickPurchaseBody": "Its lines appear here with what is left to return of each.",
    "returnAll": "Return everything left",
    "purchased": "Purchased",
    "remaining": "Remaining",
    "returnQuantity": "Return",
    "returnQuantityOf": "Quantity to return of {{description}}",
    "credited": "Amount",
    "totalCredit": "Total to deduct",
    "sections": {
      "return": "Supplier return",
      "returnLines": "Lines returned",
      "allocations": "Purchases settled",
      "document": "Return document"
    },
    "fields": {
      "kind": "Type",
      "date": "Date",
      "warehouse": "Send from warehouse",
      "reason": "Reason",
      "supplierReference": "Supplier's credit note no.",
      "supplierReferenceShort": "Supplier's CN"
    },
    "hints": {
      "returnPurchase": "Only posted purchases can be returned.",
      "allowancePurchase": "Optional. When chosen, the allowance follows its tax mode and is applied to it on posting.",
      "warehouse": "Where the returned goods leave stock.",
      "reason": "Printed on the debit note.",
      "returnLines": "Enter the quantity going back for each line, up to what is left to return.",
      "allowanceLines": "Describe what the supplier is crediting, with its VAT.",
      "supplierReference": "The number on the supplier's credit note: the document behind the VAT reduction."
    },
    "errors": {
      "returnLimit": "A quantity is more than is left to return. Correct the highlighted lines.",
      "noReturnLines": "Enter a quantity to return on at least one line.",
      "lineLimit": "Only {{quantity}} left to return.",
      "serials": "The serial numbers don't match the quantity on the highlighted lines."
    },
    "actions": {
      "post": "Post return",
      "apply": "Apply to purchases",
      "delete": "Delete draft",
      "void": "Void supplier return",
      "postMenu": "Post…",
      "deleteMenu": "Delete draft…",
      "applyMenu": "Apply to purchases…",
      "voidMenu": "Void…"
    },
    "post": {
      "title": "Post this supplier return to {{supplier}}?",
      "body": "Total {{total}}. Posting gives it a number and reduces what we owe the supplier in the books. The amount stays as credit with the supplier until it is applied to a purchase.",
      "bodyReturn": "Total {{total}}. Posting gives it a number, takes the returned goods out of stock and reduces what we owe the supplier. It is applied to {{purchase}} (open: {{open}}) automatically, up to its open balance; anything left stays as credit with the supplier.",
      "bodyPurchase": "Total {{total}}. Posting gives it a number and reduces what we owe the supplier. It is applied to {{purchase}} (open: {{open}}) automatically, up to its open balance; anything left stays as credit with the supplier."
    },
    "delete": {
      "title": "Delete this draft?",
      "body": "The draft supplier return is removed."
    },
    "apply": {
      "title": "Apply {{number}}",
      "body": "{{amount}} of this supplier return is not applied yet."
    },
    "void": {
      "title": "Void {{number}}?",
      "body": "The amounts applied to purchases are released and its journal entry is reversed. The supplier return stays on record, marked void.",
      "bodyReturn": "The amounts applied to purchases are released, its journal entry is reversed and the returned goods come back into stock. The supplier return stays on record, marked void.",
      "refundFirst": "Void refund {{number}} drawn from it first."
    },
    "toast": {
      "saved": "Draft saved",
      "posted": "Supplier return posted",
      "deleted": "Draft deleted",
      "applied": "Applied to purchases",
      "voided": "{{number}} voided",
      "postedNumber": "Supplier return {{number}} posted",
      "savedDraft": "Saved as a draft"
    },
    "empty": {
      "title": "No supplier returns yet.",
      "body": "Send goods back from a purchase, or record a price reduction a supplier gave you.",
      "drafts": "No draft returns.",
      "withCredit": "No return has unapplied credit.",
      "void": "No void returns."
    },
    "views": {
      "label": "Return views",
      "all": "All",
      "drafts": "Drafts",
      "withCredit": "Unapplied credit",
      "void": "Void"
    },
    "saveAndPost": "Save and post",
    "refShort": "Supplier's CN",
    "against": "Against",
    "fromWarehouse": "From",
    "creditStamp": "Credit",
    "creditHeld": "Credit held with the supplier",
    "stats": {
      "label": "Return figures",
      "drafts": "Drafts",
      "draftsDetail": "Waiting to be posted",
      "credit": "Unapplied credit",
      "thisMonth": "Returned this month"
    }
  },
  "statement": {
    "title": "Supplier statement",
    "balance": "Balance (what we owe)",
    "closing": "Closing balance (what we owe)",
    "hint": "From the books: purchases are credits; payments and returns are debits. The balance is what we owe the supplier; a negative balance is credit we hold with them.",
    "source": {
      "Purchase": "Purchase",
      "SupplierPayment": "Supplier payment",
      "SupplierReturn": "Supplier return",
      "SupplierRefund": "Supplier refund",
      "journal": "Journal entry"
    },
    "kind": {
      "PURCHASE": "Purchase",
      "PAYMENT": "Supplier payment",
      "RETURN": "Supplier return",
      "REFUND": "Supplier refund",
      "OTHER": "Other posting"
    },
    "creditHeld": "credit held with the supplier",
    "weOwe": "what we owe"
  },
  "aging": {
    "title": "Payables aging",
    "subtitle": "What we owe each supplier, by how long it is past due, less payments and returns not yet applied.",
    "searchLabel": "Filter suppliers",
    "searchPlaceholder": "Filter by supplier…",
    "credit": "Unapplied credit",
    "total": "What we owe",
    "empty": "We owe no supplier anything on this date.",
    "emptyBody": "Posted purchases with an open balance appear here.",
    "hint": "Days past due are counted from each purchase's due date. Amounts applied later than the date don't count yet.",
    "drill": "{{supplier}}'s purchases, {{bucket}}",
    "summary": {
      "title": "What we owe by age",
      "owed": "Owed to suppliers",
      "suppliers_one": "{{count}} supplier we owe",
      "suppliers_other": "{{count}} suppliers we owe",
      "overdue": "Overdue",
      "share": "{{share}} of what we owe",
      "creditNote": "Taken off what we owe",
      "bar": "Aging of what we owe",
      "narrowed": "Suppliers with a balance in “{{column}}”",
      "showAll": "Show all"
    }
  },
  "supplier": {
    "sections": "Supplier sections",
    "overview": "Overview",
    "statement": "Statement",
    "attachments": "Attachments",
    "newPurchase": "New purchase",
    "pay": "Pay supplier"
  },
  "refunds": {
    "title": "Supplier refunds",
    "subtitle": "Credit suppliers paid back to us: advances and returns not applied to purchases.",
    "kind": "Supplier refund",
    "new": "Record refund",
    "newTitle": "Record a supplier refund",
    "newSubtitle": "Money a supplier paid back, posted to the books straight away. The number is assigned when you save.",
    "searchLabel": "Search supplier refunds",
    "searchPlaceholder": "Search number, reference or supplier…",
    "chooseSupplierFirst": "Choose the supplier to see the credit we hold with them.",
    "sections": {
      "refund": "Refund"
    },
    "fields": {
      "date": "Refund date",
      "account": "Received into",
      "amount": "Amount received",
      "from": "From"
    },
    "source": {
      "PAYMENT": "Payment",
      "SUPPLIER_RETURN": "Supplier return"
    },
    "hints": {
      "credits": "The supplier's advances and returns not yet applied to purchases. Take back all or part of each."
    },
    "credits": {
      "none": "We hold no credit with this supplier.",
      "noneBody": "Credit appears here when a payment or a return is not fully applied to purchases.",
      "summary": "{{amount}} is received back from the supplier."
    },
    "errors": {
      "noCredit": "Enter an amount on at least one payment or return.",
      "otherSupplier": "This credit belongs to another supplier",
      "beforeCredit": "A refund can't be dated before the credit it takes back"
    },
    "actions": {
      "refund": "Record refund",
      "refundCredit": "Refund",
      "printVoucher": "Print voucher",
      "voidMenu": "Void…"
    },
    "void": {
      "body": "The credit goes back to the payments and returns it came from, and the journal entry is reversed. The refund stays on record, marked void."
    },
    "toast": {
      "created": "Supplier refund {{number}} recorded"
    },
    "empty": {
      "title": "No supplier refunds yet.",
      "body": "Record money a supplier paid back out of the credit we hold with them.",
      "void": "No void refunds."
    },
    "views": {
      "label": "Refund views",
      "all": "All",
      "void": "Void"
    },
    "saveAndPrint": "Save and print",
    "figures": {
      "fromPayments": "From payments",
      "fromReturns": "From returns"
    },
    "stats": {
      "label": "Refund figures",
      "received": "Received",
      "thisMonth": "Received this month",
      "paymentCredit": "Advances to recover",
      "returnCredit": "Return credit to recover"
    }
  },
  "actions": {
    "open": "Open",
    "print": "Print",
    "edit": "Edit"
  },
  "detail": {
    "voidedOn": "Voided on {{date}}",
    "voidedOnBy": "Voided on {{date}} by {{name}}",
    "purchasesSettled": "Purchases settled",
    "apply": "Apply",
    "unappliedNotice": "{{amount}} is not applied yet: apply it to open purchases, or have it refunded.",
    "removeNamed_payment": "Remove {{purchase}} from this payment",
    "removeNamed_return": "Remove {{purchase}} from this return",
    "removeTitle_payment": "Remove {{purchase}} from this payment?",
    "removeTitle_return": "Remove {{purchase}} from this return?",
    "remove": "Remove",
    "refundsDrawn": "Refunds drawn from it",
    "postedAt": "Posted",
    "refShort": "Ref.",
    "noneVoid": "Nothing is applied: it is void.",
    "purchaseCount_one": "{{count}} purchase",
    "purchaseCount_other": "{{count}} purchases",
    "fullyApplied": "Fully applied",
    "figures": "Figures",
    "totals": "Totals"
  },
  "trail": {
    "slipNotApplied": "{{kind}} {{number}}, {{amount}}, {{status}}, not applied to this purchase",
    "settlements_one": "Payments and returns, {{count}} document",
    "settlements_other": "Payments and returns, {{count}} documents",
    "purchases_one": "Purchases settled, {{count}} document",
    "purchases_other": "Purchases settled, {{count}} documents"
  },
  "stats": {
    "allSuppliers": "All suppliers · {{documents}}",
    "monthDetail": "{{month}} · {{documents}}",
    "companyMonth": "All suppliers · {{month}}",
    "unavailable": "Figures unavailable",
    "purchases_one": "{{n}} purchase",
    "purchases_other": "{{n}} purchases",
    "payments_one": "{{n}} payment",
    "payments_other": "{{n}} payments",
    "returns_one": "{{n}} return",
    "returns_other": "{{n}} returns",
    "refunds_one": "{{n}} refund",
    "refunds_other": "{{n}} refunds"
  },
  "serials": {
    "wholeUnits": "Serial-tracked products are counted in whole units.",
    "incomplete": "{{entered}} of {{quantity}} serial numbers: posting needs one per unit.",
    "over": "{{entered}} serial numbers for {{quantity}} units: remove some or raise the quantity.",
    "named": "{{message}}: {{serials}}",
    "errors": {
      "SERIAL_COUNT_MISMATCH": "The serial numbers don't match the quantity: posting needs one per unit, in whole units",
      "SERIAL_DUPLICATE": "Already in stock, sold, or listed twice",
      "SERIAL_NOT_AVAILABLE": "Not in stock at the return's warehouse",
      "SERIALS_NOT_TRACKED": "This product doesn't track serial numbers: clear them",
      "SERIAL_MOVED_ON": "Sold, returned or moved since"
    }
  },
  "capture": {
    "action": "Fill from a list or a document",
    "newFromDocument": "New from a document",
    "title": "Fill from a list or a document",
    "description": "The assistant reads it and fills the purchase form. You check the form and save it as usual: nothing is saved here.",
    "prompt": "Read this purchase from the supplier’s bill or the list, and fill the form.",
    "read": "Read and fill",
    "needsInput": "Type a list, or add a photo or PDF of the bill, first.",
    "or": "or",
    "list": {
      "label": "A list of items",
      "hint": "One item per line: how many, what, and the price if you have it. The supplier and the bill number can go on a line of their own.",
      "placeholder": "10 bags cement at 1.850\n5 rebar 12 mm at 3.200"
    },
    "drop": {
      "title": "Drop photos or a PDF of the bill here",
      "choose": "Choose files",
      "photo": "Take a photo",
      "rules_one": "Up to {{n}} file: a photo (JPG, PNG, WebP) or a PDF of up to {{pages}} pages, {{limit}} at most. Large photos are made smaller before they are sent.",
      "rules_other": "Up to {{n}} files: photos (JPG, PNG, WebP) or a PDF of up to {{pages}} pages, {{limit}} each. Large photos are made smaller before they are sent.",
      "titleTouch": "A photo or PDF of the bill"
    },
    "files": {
      "label": "Documents to read",
      "remove": "Remove {{name}}"
    },
    "refused": {
      "type": "Only photos (JPG, PNG, WebP) and PDFs can be read.",
      "empty": "This file is empty.",
      "size": "Over {{limit}}, even made smaller. Photograph the bill page by page, or save a smaller PDF.",
      "count_one": "Only {{n}} document can be read at once. Remove it to add another.",
      "count_other": "Only {{n}} documents can be read at once. Remove one to add another."
    },
    "privacy": {
      "short": "The document isn’t kept; what you type stays in your assistant history for your company’s retention period.",
      "details": "Details",
      "sent": "What you type and the whole document go to OpenAI under your company’s key, with everything written on it: the supplier’s address, phone and tax number too.",
      "kept": "The assistant doesn’t keep the document. What you type is kept as your message in your assistant history, and removed under your company’s retention rule.",
      "attached": "The copy that stays is the one attached to the purchase when you save."
    },
    "progress": {
      "preparing": "Making the photos smaller…",
      "reading": "Reading the document…",
      "readingList": "Reading the list…",
      "supplier": "Finding the supplier…",
      "products": "Matching products…",
      "filling": "Checking the figures and filling the form…"
    },
    "replace": {
      "title": "Replace the lines on the form?",
      "confirm": "Replace and read",
      "cancel": "Keep my lines",
      "body_one": "The form has {{n}} line you entered. Reading replaces the lines on the form.",
      "body_other": "The form has {{n}} lines you entered. Reading replaces the lines on the form."
    },
    "errors": {
      "FILE_TOO_LARGE": "A document is over {{limit}}. Remove it, or use a smaller photo or PDF, then read again.",
      "UNSUPPORTED_FILE_TYPE": "A document isn’t a photo or a PDF the assistant can read. Remove it, or save it as JPG, PNG, WebP or PDF, then read again.",
      "AI_TOO_MANY_ATTACHMENTS_one": "Only {{n}} document can be read at once. Remove the others, then read again.",
      "AI_TOO_MANY_ATTACHMENTS_other": "Only {{n}} documents can be read at once. Remove some, then read again.",
      "AI_ATTACHMENTS_NOT_ACCEPTED": "The assistant can’t take documents here right now. Type the list instead, or ask your administrator.",
      "budget": "Your company’s assistant budget for this month is used up. Enter this purchase by hand, or ask an administrator to raise the budget in Settings › AI assistant.",
      "dailyLimit": "You’ve used today’s assistant runs. Enter this purchase by hand, or read it tomorrow.",
      "prefill": "What was read couldn’t be checked",
      "AI_DOCUMENT_TOO_LONG": "This PDF has {{pages}} pages; the limit is {{max}}. Send the bill’s pages in parts.",
      "AI_DOCUMENT_TOO_LONG_unknown": "This PDF has more than {{max}} pages, the limit. Send the bill’s pages in parts.",
      "AI_BUSY": "The assistant is reading other documents. Try again in a minute."
    },
    "warnings": {
      "CREDIT_NOTE": {
        "title": "This is a credit note, not a bill",
        "body": "Record it as a supplier return instead, so it lowers what you owe."
      },
      "NOT_A_BILL": {
        "title": "This doesn’t look like a supplier’s bill",
        "body": "Check that it is a bill before you save: only a bill adds to what you owe the supplier.",
        "QUOTATION": {
          "title": "This is a quotation, not a bill",
          "body": "Nothing is owed on a quotation. Save a purchase only when the supplier bills you."
        },
        "DELIVERY_NOTE": {
          "title": "This is a delivery note, not a bill",
          "body": "It shows what was delivered, not what you owe. Enter the purchase from the supplier’s bill."
        },
        "OTHER": {
          "title": "This doesn’t look like a supplier’s bill",
          "body": "Check that it is a bill before you save: only a bill adds to what you owe the supplier."
        }
      },
      "SUPPLIER_TAX_MISMATCH": {
        "title": "The VAT number on the bill isn’t this supplier’s",
        "body": "The bill shows {{onBill}}; this supplier has {{onFile}}. Check the supplier before you save."
      },
      "SUPPLIER_NOT_FOUND": {
        "title": "The supplier on the bill isn’t one of your suppliers",
        "titleNamed": "“{{name}}” isn’t one of your suppliers",
        "body": "Choose the right supplier on the form, or add this one as a new supplier. Check its VAT number against the bill."
      },
      "SUPPLIER_INACTIVE": {
        "title": "The supplier on the bill is inactive",
        "titleNamed": "“{{name}}” is an inactive supplier",
        "body": "The supplier was left empty. Choose another supplier, or have this one made active again under Suppliers."
      },
      "DUPLICATE_BILL": {
        "title": "This bill may already be entered",
        "body": "The same supplier’s invoice number is on the purchases below. Open them and check before you save this one."
      },
      "TOTAL_MISMATCH": {
        "title": "The lines don’t add up to the document’s total",
        "body": "As read, the lines come to {{computed}} and the document says {{document}}. Check quantities, prices and VAT against it: the two totals are compared under the lines as you fix them.",
        "netTitle": "The lines don’t add up to the document’s net",
        "netBody": "No amount due was read, so the nets are compared: as read, the lines’ net (before VAT) comes to {{computed}} and the document’s is {{document}}. Check quantities, prices and discounts against it: the two nets are compared under the lines as you fix them."
      },
      "FOREIGN_CURRENCY": {
        "title": "The document is in {{currency}}, not OMR",
        "body": "The amounts were filled in as written. Convert them to OMR before you save."
      },
      "PRICE_BASIS_CONVERTED": {
        "titleToInclusive": "The document’s prices were before VAT",
        "titleToExclusive": "The document’s prices included VAT",
        "body": "Your company enters purchase prices the other way, so each unit price was converted at its line’s VAT rate. Check the line totals against the document."
      },
      "LINES_TRUNCATED": {
        "title": "The document has more lines than were read",
        "body_one": "Only the first {{n}} line was filled in. Add the rest by hand.",
        "body_other": "Only the first {{n}} lines were filled in. Add the rest by hand."
      },
      "DATE_MISSING": {
        "title": "No date was read",
        "body": "Today’s date was used. Set the date of the bill if it differs."
      },
      "NOTHING_READ": {
        "title": "No lines could be read",
        "body": "Try a sharper photo with the whole bill in view, or type the list."
      }
    },
    "review": {
      "fromDocument": "Read from the document",
      "fromList": "Read from your list",
      "notSaved": "Not saved",
      "introDocument": "Check each line against the document, fix what needs fixing, then save as usual. Nothing is saved until you do.",
      "introList": "Check each line, fix what needs fixing, then save as usual. Nothing is saved until you do.",
      "showDocument": "Show the document",
      "hideDocument": "Hide the document",
      "startOver": "Start over",
      "figures": "What was read",
      "linesRead": "Lines read",
      "linesReadSub": "filled in below",
      "matched": "Matched to a product",
      "matchedAll": "every line",
      "textLines_one": "{{n}} left as a text line",
      "textLines_other": "{{n}} left as text lines",
      "toCheck": "To check",
      "toCheckSub": "marked on the lines",
      "toCheckNone": "nothing flagged",
      "documentTotal": "Total on the document",
      "documentNet": "Net on the document",
      "notes": "The assistant’s notes",
      "attached_one": "The document is in the attachments below: saving keeps it with the purchase.",
      "attached_other": "The {{count}} documents are in the attachments below: saving keeps them with the purchase.",
      "notAttached_one": "The document isn’t attached: you can’t add attachments to purchases. Keep the paper copy.",
      "notAttached_other": "The documents aren’t attached: you can’t add attachments to purchases. Keep the paper copies.",
      "toCheckNext": "go to the next",
      "done": "Done",
      "detached_one": "The document was taken out of the attachments: saving won’t keep it with the purchase.",
      "detached_other": "The documents were taken out of the attachments: saving won’t keep them with the purchase.",
      "attachedSome_one": "{{n}} of the {{total}} documents is in the attachments below; the other won’t be kept with the purchase.",
      "attachedSome_other": "{{n}} of the {{total}} documents are in the attachments below; the others won’t be kept with the purchase.",
      "summary_one": "Filled {{n}} line; {{toCheck}} to check.",
      "summary_other": "Filled {{n}} lines; {{toCheck}} to check.",
      "announce": {
        "toCheck_one": "{{n}} still to check.",
        "toCheck_other": "{{n}} still to check.",
        "none": "Nothing left to check."
      },
      "vatMatches": "VAT number matches",
      "matchedByTax": "chosen by its VAT number",
      "notSameBill": "Not the same bill",
      "addSupplier": "Add this supplier",
      "recordReturn": "Record a supplier return"
    },
    "startOver": {
      "title": "Start over?",
      "body": "The lines on the form and what was read are cleared, with any changes you made, and the document is taken out of the attachments.",
      "cancel": "Keep the form",
      "bodyList": "The lines on the form and what was read from your list are cleared, with any changes you made."
    },
    "viewer": {
      "title": "The document",
      "description": "Check the form’s numbers against it.",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "open": "Open in a new tab",
      "openPdf": "Open the PDF",
      "pdfHere": "This browser shows the PDF in its own tab.",
      "pages": "Documents read",
      "page": "Document {{n}} of {{total}}: {{name}}",
      "frame": "The document (scrolls when zoomed)",
      "alt": "{{name}}, the document read"
    },
    "line": {
      "onDocument": "On the bill:",
      "code": "code",
      "chooseProduct": "Choose a product",
      "check": "Check this line",
      "issues": {
        "NO_PRODUCT": "No product matched. Choose one, or keep it as a text line: a text line is charged to an expense account and doesn’t go into stock.",
        "PRODUCT_UNAVAILABLE": "The product it matched is archived or can’t be bought, so this is a text line: it is charged to an expense account and doesn’t go into stock. Choose another product, or keep it as text.",
        "LOW_CONFIDENCE": "The assistant wasn’t sure of this line. Check the product and the figures against the document.",
        "QUANTITY_UNREADABLE": "The quantity couldn’t be read, so 1 was used.",
        "PRICE_FROM_TOTAL": "No unit price was read: it was worked out from the line’s total.",
        "PRICE_LAST_COST": "No price was read: the product’s cost on record was used. Check it.",
        "PRICE_MISSING": "No price was read and there’s no cost on record, so it is 0.000: enter the price.",
        "WHOLE_UNITS": "This product is counted in whole units, but the quantity read has a fraction.",
        "LINE_TOTAL_MISMATCH": "Quantity × price doesn’t give the line total printed on the document.",
        "TAX_RATE_UNKNOWN": "The VAT rate on the document isn’t one of your company’s, so it wasn’t used. Check this line’s VAT rate."
      },
      "inList": "In your list:",
      "productChosen": "Product chosen",
      "changed": "Figures changed",
      "done": "(done)",
      "markChecked": "Mark as checked",
      "markCheckedOf": "Mark as checked, line {{n}}",
      "keepText": "Keep as a text line",
      "keepTextOf": "Keep as a text line, line {{n}}",
      "keepTextHint": "It won’t go to stock",
      "undo": "Undo",
      "undoOf": "Undo, line {{n}}",
      "announce": {
        "checked": "Line {{n}} marked as checked.",
        "kept": "Line {{n}} kept as a text line.",
        "undone": "Line {{n}}: its marks are back."
      }
    },
    "totals": {
      "document": "Total on the document",
      "differ": "The lines and the document’s total are {{difference}} apart. Check quantities, prices and VAT against it.",
      "match": "Matches the total on the document.",
      "documentNet": "Net on the document",
      "differNet": "The lines’ net and the document’s net are {{difference}} apart. Check quantities, prices and discounts against it.",
      "matchNet": "Matches the net on the document."
    },
    "supplierOnBill": "On the bill:",
    "supplierInList": "In your list:"
  }
}
